module.exports = __webpack_public_path__ + "static/media/expressiveCactusRick-small.accfb30d.jpg";